var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHybridTokenIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5035 13.3333V6.66666C17.5032 6.37438 17.4261 6.08733 17.2798 5.83429C17.1336 5.58125 16.9233 5.37112 16.6702 5.22499L10.8369 1.89166C10.5835 1.74538 10.2961 1.66837 10.0035 1.66837C9.71098 1.66837 9.42357 1.74538 9.17021 1.89166L3.33687 5.22499C3.08376 5.37112 2.87352 5.58125 2.72726 5.83429C2.58099 6.08733 2.50384 6.37438 2.50354 6.66666V13.3333C2.50384 13.6256 2.58099 13.9126 2.72726 14.1657C2.87352 14.4187 3.08376 14.6289 3.33687 14.775L9.17021 18.1083C9.42357 18.2546 9.71098 18.3316 10.0035 18.3316C10.2961 18.3316 10.5835 18.2546 10.8369 18.1083L16.6702 14.775C16.9233 14.6289 17.1336 14.4187 17.2798 14.1657C17.4261 13.9126 17.5032 13.6256 17.5035 13.3333Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92017 5.83334L10.0035 10M10.0035 10L17.0868 5.83334M10.0035 10V18.3333",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHybridTokenIcon);
export default __webpack_public_path__ + "static/media/hybrid_token_icon.c51a4ef4.svg";
export { ForwardRef as ReactComponent };